export const demoUsers = [
    {
        username: 'PastorFrank',
        password: 'password'
    },
    {
        username: 'Andrew',
        password: '12345678',
    },
    {
        username: 'admin',
        password: 'admin2468',
    },
    {
        username: 'Cindi',
        password: 'qwertyrules',
    },
    {
        username: 'Ludo',
        password: 'nucamp4life',
    },
    {
        username: 'notarobot',
        password: '1101100010101101',
    },
]